import PrintShell, { PrintField, PrintRow, PrintSectionHeader } from '../../../components/print/PrintShell';

export default function FuneralPrintTemplate({ funeral: f }) {
  if (!f) return null;
  return (
    <PrintShell printClass="funeral-print-only" formTitle="FUNERAL FORM">
      <PrintSectionHeader title="Deceased Information" />
      <PrintField label="Name of Deceased" value={f.deceased_name} />
      <PrintField label="Address" value={f.deceased_address} />
      <PrintRow fields={[
        { label: 'Date of Death', value: f.date_of_death },
        { label: 'Age', value: f.age, flex: 0.5 },
      ]} />

      <PrintSectionHeader title="Family" />
      <PrintRow fields={[
        { label: 'Next of Kin', value: f.next_of_kin },
        { label: 'Relationship', value: f.relationship, flex: 0.6 },
      ]} />
      <PrintRow fields={[
        { label: 'Address', value: f.family_address },
        { label: 'Phone', value: f.family_phone, flex: 0.6 },
      ]} />

      <PrintSectionHeader title="Funeral Home" />
      <PrintField label="Funeral Name" value={f.funeral_home_name} />
      <PrintField label="Address" value={f.funeral_home_address} />
      <PrintRow fields={[
        { label: 'Name', value: f.funeral_home_contact_name },
        { label: 'Phone', value: f.funeral_home_phone },
      ]} />
      <PrintRow fields={[
        { label: 'Wake', value: f.wake_date },
        { label: 'Time', value: f.wake_time },
      ]} />

      <PrintSectionHeader title="Funeral Mass" />
      <PrintRow fields={[
        { label: 'Cemetery', value: f.cemetery },
        { label: 'Date', value: f.mass_date, flex: 0.5 },
        { label: 'Time', value: f.mass_time, flex: 0.4 },
      ]} />
      <PrintRow fields={[
        { label: 'Organist', value: f.organist },
        { label: 'Phone', value: f.organist_phone },
      ]} />
      <PrintField label="Language" value={f.language} />
    </PrintShell>
  );
}
